module.exports = "<p>\n  thankyou-modal-component works!\n</p>\n"